import {Routes} from "./routes";

export const [, HANDLE_TOKEN, DOCUMENT_SLUG_TOKEN] = Routes.PROJECT_BY_SLUG.split("/");

function escapeRegExp(value: string): string {
    return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export const replaceAllLiteral = (input: string, search: string, replacement: string): string =>
    input.replace(new RegExp(escapeRegExp(search), "g"), () => replacement);

export const resolveProjectRoutePlaceholders = (
    input: string,
    values: {
        readonly handle: string;
        readonly documentSlug: string;
    },
): string => {
    if (!HANDLE_TOKEN || !DOCUMENT_SLUG_TOKEN) {
        return input;
    }

    return replaceAllLiteral(
        replaceAllLiteral(input, HANDLE_TOKEN, values.handle),
        DOCUMENT_SLUG_TOKEN,
        values.documentSlug,
    );
};
